const { AxiosAdapter } = require("../http/http-adapter");
const queryString = require("query-string");

class Order {
    constructor({ accessToken, baseUrl }) {
        this.accessToken = accessToken
        this.baseUrl = baseUrl;
        this.request = new AxiosAdapter(this.baseUrl);
        this.request.setAuthHeader(this.accessToken);
    }

    list(params) {
        return new Promise((resolve, reject) => {
            const qs = queryString.stringify(params);
            this.request
                .get(`/orders?${qs}`)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    listItems({ orderId }) {
        return new Promise((resolve, reject) => {
            this.request
                .get(`/orders/${orderId}/items`)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

module.exports = {
    Order,
};
